import React from "react";

function Lightbox({ images, index, onClose, onPrev, onNext }) {
  return (
    <div className="lightbox-backdrop" onClick={onClose}>
      <button className="lightbox-close" onClick={onClose}>
        &times;
      </button>

      <button
        className="lightbox-prev"
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
      >
        &#10094;
      </button>

      <img
        className="lightbox-image"
        src={images[index]}
        alt=""
        onClick={(e) => e.stopPropagation()}
      />

      <button
        className="lightbox-next"
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
      >
        &#10095;
      </button>
    </div>
  );
}

export default Lightbox;
